module.exports = __webpack_public_path__ + "media/images/official/special_double_life_hero_sp-df80d677b101f22e4a9340e466531994.webp";